import { useEffect, useState } from 'react';

import { Tick } from '../@types/State';
import RestUtilities from '../services/RestUtilities';

const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
const days = 24;
const years = 10;
export const useTicks = () => {
  const [ticks, setTicks] = useState<Tick[] | undefined>(undefined);

  const setTicksData = async () => {
    const response = await RestUtilities.get(`Data/v1/Ticks`);
    if (response.ok) {
      const ticks: Tick[] = response.content;
      setTicks(ticks);
    }
  };

  useEffect(() => {
    if (!ticks) {
      setTicksData();
    }
  }, [ticks]);

  return { ticks, days, months, years };
};
